export const prettifySegment = (
  value: string | undefined,
  options?: { unknownLabel?: string }
) => {
  if (!value) return options?.unknownLabel ?? 'Unknown Breed';
  const decoded = decodeURIComponent(value);
  return decoded
    .split('-')
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');
};

export const prettifyProvince = (value: string | undefined) => {
  if (!value) return 'Unknown Province';
  const decoded = decodeURIComponent(value);
  if (decoded.length <= 3) {
    return decoded.toUpperCase();
  }

  return decoded
    .split('-')
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');
};

export const prettifyListing = (value: string | undefined) => {
  if (!value) return 'Listing';
  const decoded = decodeURIComponent(value);
  return decoded.replace(/[^a-z0-9-]/gi, '').toUpperCase();
};

/**
 * Hard cap for page <title> length. The root layout appends " | Paction"
 * (10 chars), so the page-title portion is capped at 50 to keep the rendered
 * title within Google's ~60-char recommendation. Truncation prefers a word
 * boundary and appends an ellipsis.
 */
export const MAX_PAGE_TITLE_LEN = 50;

export const capTitle = (
  title: string,
  max: number = MAX_PAGE_TITLE_LEN
): string => {
  if (title.length <= max) return title;
  const partial = title.slice(0, max - 1);
  const lastSpace = partial.lastIndexOf(' ');
  const base = lastSpace > max / 2 ? partial.slice(0, lastSpace) : partial;
  return `${base.trimEnd()}…`;
};
